export default __webpack_public_path__ + "static/media/JOSA CLASS-7_SYLLABUS_2025-26.64f8a0b6.pdf";